import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { AutomatedListView } from './automated-list-view';
import { useAutomatedTable } from './table/use-automated-table';
export var AutomatedListViewContainer = function () {
    var _a = useAutomatedTable(), table = _a.table, isLoading = _a.isLoading, onRowClick = _a.onRowClick;
    var isTabletOrSmaller = useBreakpoints().isTabletOrSmaller;
    var handleTurnOnAllCampaigns = function () {
        // TODO: Implement turn on all campaigns functionality
    };
    return (_jsx(AutomatedListView, { table: table, isLoading: isLoading, isTabletOrSmaller: isTabletOrSmaller, handleTurnOnAllCampaigns: handleTurnOnAllCampaigns, onRowClick: onRowClick }));
};
